import styled from "styled-components";

export const PageWrapper = styled.div`
  width: 100%;
  margin: 0 auto;
`;
